<template>
  <div>
    <div class="oukosher-form form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <h1>OU Kosher Initial Invoices</h1>
          <FormSection title="Payment Amount">
            <FormRow>
              <AmountSelectorSimple />
              <ErrorLabel field="amount" />
            </FormRow>
          </FormSection>
          <FormSection title="Company Info">
            <FormRow inline>
              <FormCol field="custom.CompanyName" :flex="2">
                <FormInput type="text" />
                <ErrorLabel field="custom.CompanyName" />
              </FormCol>
              <FormCol field="custom.CompanyNumber" :flex="2">
                <FormInput type="text" />
                <ErrorLabel field="custom.CompanyNumber" />
              </FormCol>
            </FormRow>
            <FormRow inline>
              <FormCol field="custom.ContactName">
                <FormInput type="text" />
              </FormCol>
              <FormCol field="custom.ContactEmailAddress">
                <FormInput type="email" />
              </FormCol>
            </FormRow>
            <FormRow inline>
              <FormCol field="custom.InvoiceNumber" :flex="2">
                <FormInput type="text" />
                <ErrorLabel field="custom.InvoiceNumber" />
              </FormCol>
            </FormRow>
            <FormRow>
              <FormLabel class="control-label"> Comments </FormLabel>
            </FormRow>
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Comments" />
            </FormRow>
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="custom.SubmittersInformation" :flex="1">
                <FormInput type="text" />
                <ErrorLabel field="custom.SubmittersInformation" />
              </FormCol>
              <FormCol field="custom.SubmitterEmailAddress" :flex="1">
                <FormInput type="email" />
                <ErrorLabel field="custom.SubmitterEmailAddress" />
              </FormCol>
            </FormRow>
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>              
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Checkout" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm();

    setValue("description", "OU Kosher Initial Invoices");

    return {
      form,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep.oukosher-form.form-container.ou-donation-form {
  border-radius: 5px;
  box-shadow: 0 0 6px 1px #b0b2ab;
  margin: 30px auto;
  max-width: 650px;
  padding: 20px;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

h3 {
  text-align: center;
  margin-top: 10px;
  font-size: 23px;
  margin-bottom: 0px;
  padding-bottom: 13px;
}

::v-deep .oudonate-other-amount.USD {
  .amount_other__wrapper::before {
    padding: 11px 8px;
    border-right: 1px solid #ddd;
    height: auto;
  }
}
::v-deep .form-container.ou-donation-form {
  margin: 4px 0px;
  padding: 0px;
  box-shadow: none;

  label.control-label {
    max-width: 170px;
  }
}
</style>
